import {Orgs} from '../../model/org.model';

export class GetOrgsAction {
  static readonly type = '[Orgs] Get Orgs';
}

export class GetOrgsSuccessAction {
  static readonly type = '[Orgs] Get Orgs Success';
  constructor(public payload: Orgs) {}
}

export class GetOrgsFailureAction {
  static readonly type = '[Orgs] Get Orgs Failure';
  constructor(public payload: Error | string) {}
}

export class SetOrgAction {
  static readonly type = '[Orgs] Set Org';
  constructor(public id: string | null | undefined) {}
}

export class SwitchOrgAction {
  static readonly type = '[Orgs] Switch Org';
  constructor(public id: string) {}
}
